import React, { useState } from 'react'
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Typography,
} from '@material-ui/core/index'
import { strings } from '../../../../localization/strings'
import Loader from '../../../loaders/dots_loader/index'
import TextField from '@material-ui/core/TextField'
import { setContactTime, getContactTime } from '../../../../helpers/restHelpers'

const ContactTimeDialog = ({ courierParcelId, actionDone }) => {
    const [open, setOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const [contactTime1, setContactTime1] = useState({ from: '00:00', to: '00:00' })
    const [contactTime2, setContactTime2] = useState({ from: '00:00', to: '00:00' })

    const getActualContactTime = (courierParcelId) => {
        setLoading(true)
        getContactTime(courierParcelId)
            .then((response) => {
                if (response.contactTime1) {
                    const contact1 = response.contactTime1
                    setContactTime1({ from: contact1.split(" - ")[0], to: contact1.split(" - ")[1] })
                }
                if (response.contactTime2) {
                    const contact2 = response.contactTime2
                    setContactTime2({ from: contact2.split(" - ")[0], to: contact2.split(" - ")[1] })
                }
            })
            .catch((err) => console.error(err))
            .finally(() => setLoading(false))
    }

    const handleClickOpen = () => {
        getActualContactTime(courierParcelId)
        setOpen(true)
    }

    const handleClose = (force) => {
        if (force !== true) {
            if (loading) return
        }
        setOpen(false)
        setLoading(false)
        setContactTime1({ from: '00:00', to: '00:00' })
        setContactTime2({ from: '00:00', to: '00:00' })
    }

    const handleTimeChange = (e, contactTime, setContactTime) => {
        const { name, value } = e.target
        setContactTime({ ...contactTime, [name]: value })
    }

    const isValidTimeRange = (timeFrom, timeTo) => {
        const [fromHours, fromMinutes] = timeFrom.split(':').map(Number)
        const [toHours, toMinutes] = timeTo.split(':').map(Number)
        return toHours > fromHours || (toHours === fromHours && toMinutes > fromMinutes)
    }

    const validateTime = (timeRange) => {
        if (timeRange == null) return true

        const [timeFrom, timeTo] = timeRange.split(' - ')

        if (!isValidTimeRange(timeFrom, timeTo)) {
            window.showDialog(
                {
                    title: strings.contactTimeErrorTitle,
                    message: strings.contactTimeRangeError
                },
            )
            return false
        }
        return true
    }

    const formatTimeRange = (from, to) => (from && to) ? `${from} - ${to}` : null
    const getTimeRange = (from, to) => (from === '00:00' && to === '00:00') ? null : formatTimeRange(from, to)

    const confirm = (event) => {
        event.preventDefault()
        setLoading(true)

        let timeRange1 = getTimeRange(contactTime1.from, contactTime1.to)
        let timeRange2 = getTimeRange(contactTime2.from, contactTime2.to)

        const data = {
            courierParcelId: courierParcelId,
            contactTime1: timeRange1,
            contactTime2: timeRange2
        }

        if (validateTime(timeRange1) && validateTime(timeRange2)) {
            setContactTime(data)
                .then(() => {
                    setOpen(false)
                    window.showDialog(
                        {
                            title: strings.contactTimeSuccessTitle,
                            message: strings.contactTimeSuccess
                        },
                        () => {
                            actionDone();
                            handleClose()
                        }
                    )
                })
                .catch(() => {
                    window.showDialog(
                        {
                            title: strings.contactTimeErrorTitle,
                            message: strings.contactTimeError,
                        },
                    )
                })
        }
        setLoading(false)
    }

    return (
        <div style={{ width: '100%' }}>
            <div onClick={handleClickOpen}>
                {strings.contactTimeButton}
            </div>
            <Dialog
                open={open}
                maxWidth={'sm'}
                fullWidth
            >
                <DialogTitle id="alert-dialog-title">
                    {strings.contactTimeDialogTitle}
                </DialogTitle>
                <DialogContent dividers>
                    <form id='timeForm' onSubmit={confirm}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Typography variant='subtitle1'>Primer horario</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    label="Desde"
                                    type="time"
                                    fullWidth
                                    variant='outlined'
                                    size='small'
                                    value={contactTime1.from}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    inputProps={{
                                        step: 300,
                                        name: 'from'
                                    }}
                                    onChange={(e) => handleTimeChange(e, contactTime1, setContactTime1)}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    label="Hasta"
                                    type="time"
                                    fullWidth
                                    value={contactTime1.to}
                                    variant='outlined'
                                    size='small'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    inputProps={{
                                        step: 300,
                                        name: 'to'
                                    }}
                                    onChange={(e) => handleTimeChange(e, contactTime1, setContactTime1)}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <Typography variant='subtitle1'>Segundo horario</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    label="Desde"
                                    type="time"
                                    fullWidth
                                    value={contactTime2.from}
                                    variant='outlined'
                                    size='small'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    inputProps={{
                                        step: 300,
                                        name: 'from'
                                    }}
                                    onChange={(e) => handleTimeChange(e, contactTime2, setContactTime2)}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    label="Hasta"
                                    type="time"
                                    fullWidth
                                    value={contactTime2.to}
                                    variant='outlined'
                                    size='small'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    inputProps={{
                                        step: 300,
                                        name: 'to'
                                    }}
                                    onChange={(e) => handleTimeChange(e, contactTime2, setContactTime2)}
                                />
                            </Grid>
                        </Grid>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleClose}
                        color="primary"
                        disabled={loading}
                    >
                        {strings.close}
                    </Button>
                    <Button
                        color="primary"
                        autoFocus
                        disabled={loading}
                        type='submit'
                        form='timeForm'
                    >
                        {strings.continue}
                    </Button>
                </DialogActions>
                {loading ? <Loader /> : null}
            </Dialog>
        </div>
    )
}

export default ContactTimeDialog